import { useContext } from "react";
import { AuthContext } from "../providers/auth-provider";

const UseAuth = () => {
  const auth = useContext(AuthContext);

  return auth;
};

export default UseAuth;
